import appLogo from '@src/assets/images/logo/kaynex.svg'
import appIcon from '@src/assets/images/logo/kaynex-favicon.svg'

// Template config options
const themeConfig = {
  app: {
    appName: '',
    projectName: 'Base Project',
    appLogo,
    appIcon,
    appFavIcon: '',
    appLoader: '',
    primaryColor: '#ec6671'
  },
  layout: {
    isRTL: false,
    modulePageActiveTab: '1',
    skin: 'light', // light, dark, bordered, semi-dark
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white'
    },
    footer: {
      type: 'static'
    },
    customizer: false,
    scrollTop: true,
    toastPosition: 'top-right',
    paymentTransactionTab: 'laundryOrder'
  }
}

export default themeConfig
